<template>
    <div style="background:#fff; margin-left:3px; "> 
        <div style="border-bottom:2px solid #389;display:flex">
            <div style="line-height:30px;margin-left:5px;margin-right:4px;font-size:11px"> 供应商类别</div>
            <el-select v-model="supty"  @change="getSup" size="small" style="width:140px;  ">
                <span v-for="item in suptyArr" :key='item.CODE'>
                    <el-option :label="item.CNAME" :value="item.CODE"></el-option>
                </span>
            </el-select>
            <div style="line-height:30px;margin-left:15px;margin-right:4px;font-size:11px">供应商名称</div>
            <el-select v-model="supval"  filterable size="small" style="width:190px;  ">
                <span v-for="item in supOption" :key='item.CODE'>
                    <el-option :label="item.SUPNM" :value="item.IDNO"></el-option>
                </span>
            </el-select>
            <div style="line-height:30px;margin-left:5px;margin-right:4px;font-size:11px">建议到货日期</div>
            <el-date-picker type="date" size="small"  v-model="dateval"   value-format="yyyy-MM-dd" style="width:135px" ></el-date-picker>  
            <el-button type="primary" @click="alloCate" size="small"  style=" margin-left:10px;height:30px;font-size:12px;font-weight:600">分配记录</el-button>
            <el-button type="info" @click="btnExit" size="small"  style=" margin-left:30px;height:30px;font-size:12px;font-weight:600">退出</el-button>
            <el-button type="danger" @click="genPo" size="small"  style=" margin-left:30px;height:30px;font-size:12px;font-weight:600">生成采购单</el-button>
        </div>
        <el-table  :data="tmpData" 
            border                            
            size="small"
            class="custom-table-border"
            ref="refreq"
            header-cell-class-name="clearPadding"
            :cell-style="{padding:'2px'}"
            :row-key="getRowKey"
            :row-class-name="rowClass"
            :height="400" 
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            highlight-current-row > 
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column v-for="(item ) in reqCol.filter(item=>item.thide=='N')" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox' && item.sortable=='N'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-checkbox v-if="item.key=='SEL'" @change="selChg(v_row[item.key])" true-label="Y"  false-label="N" v-model="v_row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number" placeholder="数字框" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" :disabled="item.key!=='SEL'" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]"></span>
                    </template>
                </el-table-column> 
            </el-table-column> 
        </el-table>
        <div class="one-div" style="margin-top:5px">
           <span class="oneRow"> 已选择请购明细 </span>
           <el-button  @click="nextData=[]" type="danger" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green">
                <i class="iconfont icon-shanchu1" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>清除所有选择记录
            </el-button>
        </div>
        <el-table  :data="nextData" 
            border                            
            size="small"
            class="custom-table-border"
            ref="refdtl"
            :cell-style="{padding:'2px'}"        
            :min-height="250" 
            style="margin-top:-8px"
            highlight-current-row > 
            <el-table-column label="序号" type="index" width="60"></el-table-column>   
            <el-table-column v-for="(item ) in reqCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox' && item.sortable=='N'"
                :min-width="item.width">
                <template  slot-scope="scope" >
                    <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                    <div v-else  >{{scope.row[item.key]}}</div>
                </template>
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="120">
                <template slot-scope="scope">
                    <i class="iconfont icon-shuaxin" style="color:#409EFF;font-size:12px;margin-right:4px;"></i>
                    <el-link  @click="nextRef(scope.row,scope.$index)" :underline="false" style="font-size:10px; "><span style="font-size:11px;margin-right:5px">获取</span></el-link> 
                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:4px;"></i>
                    <el-link  @click="nextDel(scope.row,scope.$index)" :underline="false" style="font-size:10px; "><span style="font-size:11px;">删除</span></el-link> 
                </template>
            </el-table-column>
        </el-table>
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" v-dialogDrag  width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
 
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import { getDate } from '../../api/Select' 
export default {
    //props:['v_table','tabCol' ],
    props: {
        reqData:{
            type: Array,
        } ,
 
        v_table:{
            type: String,
        },
 
    },
    data () {
        return {
            oper:'like',
            dateval:'',
            suptyArr:[],
            supty:'285',
            v_loading:false,
 
            allData:[] ,//表数据
            reqCol:[],
            supval:'',
            tmpData:[],
            promptWin:false,
            prompt:'',
 
            v_url:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            supOption:[],
            loadWin:false,
            nextData:[],
            v_row:{},
        }
    },
    created () {
        this.getTabField()
    },
    watch: {
 
 
    },
    mounted () {   
        getBaseData(this.v_url,'PARENTNO','284','','','v_sys_base','').then(res=>{
            this.suptyArr =res.result
        })
        this.$nextTick(()=>{
            this.tmpData= this.reqData.filter(item=>item.QTY>0)
            setTimeout(() => {
                this.$refs['refreq'].doLayout()
            }, 500);
        })
        this.getSup()
    },
    computed: {
        maxHeight() {
          return  window.innerHeight -585
        },
 
    },
    methods: { 
        selChg(val){
            this.tmpData.forEach(item=>{
                item['SEL'] =val
            })
        },
        nextDel(row,index){
            //this.reqData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N',SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        //获取最近供应商
        nextRef(row,index){
            this.$confirm('你要获取最近供应商与单价吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (row['MAT_SUPNO']){
                    let v_prc=row['PRC']
                    if (row['MAT_PRC']){
                        v_prc =row['MAT_PRC']
                    }
                    this.nextData.splice(index,1,Object.assign(row,{SUPNO:row['MAT_SUPNO'],SUPNM:row['MAT_SUPNM'],PRC:v_prc}))   
                }
            }).catch(err=>{})       
        },
        getRowKey(row){
            return row.index
        },
        //字段查询
        inputQry(){
            this.qryTabData()  
        },
        rowShow(){
            this.v_row={}
            this.tmpData=this.reqData.filter(item=>item.QTY>0)
        } ,
        getSup(){
            this.supval =''
            getBaseData(this.v_url,'CORPID',this.v_corpid ,'supty',this.supty,'v_bs_sup','').then(res=>{
                this.supOption =res.result
            })
        },
 
        //分配
        alloCate(){
            if (this.tmpData.filter(item=>item['SEL']=='Y').length==0){
                this.promptWin =true
                this.prompt ='请选择记录'
                return 
            }else{
                this.tmpData.forEach((item,index)=>{
                    if (item.SEL=='Y'){
                        if (!this.supval && !item['SUPNO'] && !item['SUPNM']){
                            this.promptWin =true
                            this.prompt ='分配建议供应商不能为空'
                        }else if (!this.dateval && !item['SHPDTTM']){
                            this.promptWin =true
                            this.prompt ='分配建议到货日期不能为空'
                        }else{
 
                            if (this.supval && !item['SUPNO'] ){
                                this.$set(item,'SUPNO',this.supval)
 
                                this.supOption.some(item2=>{
                                    if (item2['IDNO']==this.supval) {
                                        this.$set(item,'SUPNM',item2['SUPNM'])
                                    }
                                })
                            }
                            if (this.dateval &&!item['SHPDTTM'] ){
                                //item['SHPDTTM'] =this.dateval
                                this.$set(item,'SHPDTTM',this.dateval)
                            }
                            //item['RMK'] =this.rmkval
                            this.$set(item,'RMK',this.rmkval)
                            let v_bool =this.nextData.some(it=>it['IDSEQ']==item['IDSEQ'] && it['LSTSEQ']==item['LSTSEQ'])
                            if (!v_bool){
                                this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ 'SEL':'N'}))))
                            }
                        }
                    }
                })
                this.v_row['SEL']='N'
            }
        },
        btnExit(){
            this.$emit('child-exit' )
 
        },
        //生成采购单
        genPo(){
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt ='下推的记录不能为空' 
            }else if (this.nextData.filter(item=>!item['SUPNM']).length>0){
               this.promptWin =true
               this.prompt ='下推的记录中供应商不能为空，请分配' 
            }else{
                this.$confirm('你确定要下推生成采购订单吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.loadWin =true   
                    let v_json =JSON.stringify(this.nextData)
                    let v_action =this.v_username+getDate('full')
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/next_genpo',
                        data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$emit('child-sure','200')
                        }else{
                            this.$emit('child-sure','300')
                        }
                        this.loadWin =false
                    })
                }).catch(()=>{})   
            
            }
        },
  
        rowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['POSTFG']=='未开始' ){
                return 'row-gray'
            }else if (row['POSTFG']=='进行中' ){
                return 'row-blue'
            }else if (row['POSTFG']=='已完成' ){
                return 'row-green'
            }else if (row['POSTFG']=='异常' ){
                return 'row-yellow'
            } else if (row['POSTFG']=='加急' ){
                return 'row-red'
            }else{
                return 'row-gray'
            } 
        },
        //查询表格数据
        qryTabData(){
            Object.keys(this.v_row).forEach(item=>{
                //console.log(item, this.v_row[item])
                if (this.v_row[item] ){
                    this.tmpData =this.reqData.filter(it=>it[item].indexOf(this.v_row[item])>-1)
                }
            }) 
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','95','lstseq','2265','thide','N',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.reqCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
 
</script>
<style scoped lang="less" >
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .row-red  {
        color: red;
    }
    .el-table .ok-row  {
        color: green;
        font-weight:700;
    }
    .el-table .row-gray  { //未开始颜色
        color: gray;
        font-weight:700;
    }
    .el-table .row-blue  { //进行中颜色
        color: blue;
        font-weight:700;
    }
    .el-table .row-green  { //已完成颜色
        color: green;
        font-weight:700;
    }
    .el-table .row-yellow  { //异常颜色
        color: rgb(255, 165, 0) ;
        font-weight:700;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
 
</style>
